import React from 'react';
import PropTypes from 'prop-types';
import RecipeTeaser from 'components/recipe-teaser/recipe-teaser';
import LinkButton from 'components/link-button/link-button';
import useBreakpoints from 'hooks/use-breakpoints';
import Carousel from 'components/carousel';
import RelatedItemsHeader from 'components/related-items-header/related-items-header';
import cn from 'classnames';
import { BLOCK_PLACES } from 'js/constants';

const RelatedRecipesBlock = ({
  seeAllLink,
  heading,
  items,
  backgroundColor,
  place,
}) => {
  const { isDesktop } = useBreakpoints(true);
  const useColumnLayoutOnDesktop =
    place === BLOCK_PLACES.mainContentArea && items && items.length < 4;
  return (
    <div
      className={cn('related-recipes-block', {
        [`related-recipes-block_in-${place}`]: place,
        [`related-recipes-block_col-layout related-recipes-block_col-count-${items.length}`]:
          useColumnLayoutOnDesktop,
        [`related-recipes-block_with-bg-color`]: backgroundColor,
      })}
      style={{ backgroundColor }}
    >
      <div className="related-recipes-block__grid">
        <RelatedItemsHeader
          heading={heading}
          seeAllLink={seeAllLink}
          useVerticalLayout={useColumnLayoutOnDesktop}
          className="related-recipes-block__header"
        />
        {isDesktop ? (
          <React.Fragment>
            <div className="related-recipes-block__teasers">
              <ul className="related-recipes-block__teasers-list">
                {items.map((teaser, index) => (
                  <li
                    key={index}
                    className="related-recipes-block__teasers-item"
                  >
                    <RecipeTeaser
                      {...teaser}
                      className="related-recipes-block__teaser"
                    />
                  </li>
                ))}
              </ul>
            </div>
          </React.Fragment>
        ) : (
          <div className="related-recipes-block__container">
            <Carousel items={items} itemComponentName="RecipeTeaser" />
            {seeAllLink && (
              <LinkButton
                {...seeAllLink}
                className="related-recipes-block__see-all-button"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

RelatedRecipesBlock.propTypes = {
  seeAllLink: PropTypes.exact(LinkButton.propTypes),
  heading: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.exact(RecipeTeaser.propTypes)).isRequired,
  backgroundColor: PropTypes.string,
  place: PropTypes.string,
};

export default RelatedRecipesBlock;
